'use strict';

import * as lsDom from './dom.js';
import * as lsDate from './date.js';
import { get_token, fetchCroisieres, filterResults, displayGares, display_afficheur_title } from './api.js';
/*
  À FAIRE :
  – L'erreur lancé dans le try {…} de la fonction fetchCroisieres() n'est pas capturée dans le catch()
*/

/* ******************************************************
PROCESS:
1. On crée les ≠ variables et les éléments du DOM qui nous permettront d'insérer les résultats (les départs des croisières pour un port donnée et pour une croisière donnée.
2. On demande à l'API un TOKEN
3. On crée une fonction asynchrone qui se charge d'interroger l'API grâce au Token précédemment obtenu.
4. On filtre les résultat obtenus (on ne veut pas toutes les croisières pour un port donné, ni les croisières non-vendable sur Internet ou les horaires du jour dépassés.)
5. On crée une super fonction asynchrone, qui fait tout : demande le token, fetch les datas, et les traitent.
******************************************************* */

var horaire_depart_choisi = null;
var horaire_retour_choisi = null;

async function build_horaires_table(token, placeholder, tab_codes_croisiere, dateDebut = lsDate.today, dateFin) {
	let posts = await fetchCroisieres(token, tab_codes_croisiere, dateDebut, dateFin, lsDom.END_POINT, lsDom.affiche_etapes);
	//console.log(posts);
	posts = filterResults(posts, tab_codes_croisiere, lsDom.ar_journee); // On filtre le tableau des résultats reçu de l'API (permet de grouper aussi les horaires par jour - si)
	display_afficheur_title(posts, lsDom.title); // Titre principal du ls_container
	let table_horaires = display_ligne_horaire(posts, tab_codes_croisiere, lsDom.affiche_dispo, lsDom.affiche_etapes, lsDom.affiche_tps_traversee, lsDom.affiche_retour_journee); // On construit le marquage HTML des blocs horaires (y compris les h4 avec le lib_croisiere)
	placeholder.innerHTML = table_horaires; // On insère le HTML dans le document.
}

async function populate_select_mois(select) {
	const date_debut_saison = lsDate.get_date_debut_saison(window.lsresa.saison[0], window.lsresa.saison[1]); // retourne un tab. ['YYYY-MM-DD', 'mois YYYY']
	const date = new Date(date_debut_saison[0]);
	let option_list = `<option value="">Choisir un mois</option>
                    <option value="${date_debut_saison[0]}" selected>${date_debut_saison[1]}</option>`;
	// On met autant de mois dans le select qu'il y a de mois dans la saison, sauf si un troisième parmètre «nbre de mois à afficher» a été défini dans les options. En effet, une cie peut travailler toute l'année, mais ne déploie peut-être ses croisières que de 2 mois en 2 mois. Dans ce cas, il n'est pas nécessaire de mettre dans le select toute l'année : cela impliquerait uniquement que les internautes reçoivent des messages «Pas de départ programmé»
	let limit;
	if (window.lsresa.saison[2]) {
		limit = window.lsresa.saison[2] - 1;
	} else {
		limit = window.lsresa.saison[1] - window.lsresa.saison[0];
	}
	for (let i = 0; i < limit; i++) {
		let month = date.setMonth(date.getMonth() + 1);
		option_list += `<option value="${lsDate.ls2date(month)}">${lsDate.lsPrintMonth(month)}</option>`;
	}
	select.innerHTML = option_list;

	//const token = await get_token(lsDom.TOKEN_URL);
	//console.log(lsDom.cie, lsDom.mode);
	const token = await get_token(lsDom.cie, lsDom.mode);
	//console.log("token", token);

	// Lors du changement de date, on rappelle la fonction d'affichage des horaires avec les bonnes
	// A mettre avant le await build_horaires_table() sinon, lorsque le tableau des horaires n'est pas construit pour le premier mois, il y a impossibilité de checker d'autres mois.
	lsDom.select_mois.addEventListener('change', async function (evt) {
		lsDom.reset_alert();
		// On ne fabrique pas le tableau d'horaire si on n'a pas de date (sinon erreur)
		// On élimine le premier choix du select qui a une value à ''
		if (this[this.selectedIndex].value !== '') {
			await build_horaires_table(
				token,
				lsDom.tab_allers,
				lsDom.tab_croisieres_aller,
				lsDom.select_mois[lsDom.select_mois.selectedIndex].value,
				lsDate.first_of_next_month(lsDom.select_mois[lsDom.select_mois.selectedIndex].value)
			);
			// On ne fabrique le 2nd tableau des départ que si un retour est défini :
			if (lsDom.tab_croisieres_retour !== undefined) {
				await build_horaires_table(
					token,
					lsDom.tab_retours,
					lsDom.tab_croisieres_retour,
					lsDom.select_mois[lsDom.select_mois.selectedIndex].value,
					lsDate.first_of_next_month(lsDom.select_mois[lsDom.select_mois.selectedIndex].value)
				);
				lsDom.tab_allers.classList.add('ar');
				lsDom.tab_retours.classList.add('ar');
				// On attache les listeners au bloc des allers et des retours (seulement pour les A/R)
				// Pour les croisières AS ou AR(non ARDMUL), la réservation se fait via un lien HTML sans écouteur d'evt.
				btn_horaires_attach_event('allers');
				btn_horaires_attach_event('retours');
			}
		}
	});

	// Par défaut on affiche le tableau des horaires pour le début de saison ou pour le mois en cours.
	await build_horaires_table(
		token,
		lsDom.tab_allers, // la div placehorder
		lsDom.tab_croisieres_aller, // les croisières pour l'aller
		date_debut_saison[0],
		lsDate.first_of_next_month(date_debut_saison[0])
	);

	//console.log('tab_croisieres_retour', lsDom.tab_croisieres_retour);

	// On ne fabrique le 2nd tableau des départs que si un retour est défini :
	if (lsDom.tab_croisieres_retour !== undefined) {
		await build_horaires_table(
			token,
			lsDom.tab_retours, // la div placehorder
			lsDom.tab_croisieres_retour, // les croisières pour le retour
			date_debut_saison[0],
			lsDate.first_of_next_month(date_debut_saison[0])
		);
		lsDom.tab_allers.classList.add('ar');
		lsDom.tab_retours.classList.add('ar');

		// On attache les listeners au bloc des allers et des retours (seulement pour les A/R)
		// Pour les croisières AS ou AR(non ARDMUL), la réservation se fait via un lien HTML sans écouteur d'evt.
		btn_horaires_attach_event('allers');
		btn_horaires_attach_event('retours');
	}

	// On attache les listenners sur les horaires
}

populate_select_mois(lsDom.select_mois);

// ******************************************************
// FONCTIONS
// ******************************************************

/**
 * GÉNÉRATION DU MARQUAGE HTML DE CHAQUE LIGNE D'HORAIRE (une par date)
 * et du titre de chaque tableau d'horaire ("ex : de Fromentine vers Yeu")
 * @param {array} arr : le tableau des résultats
 * @returns {string} un ensemble de <li></li> sous forme de chaine de caractère
 */
function display_ligne_horaire(results, tab_id_croisiere, affiche_dispo, affiche_etapes, affiche_tps_traversee) {
	let li = `<h4 class="lib-croisiere">${displayGares(results)[2]}</h4><ul class="departures-list">`;
	// let li = `<h4 class="lib-croisiere">De <span class="lib-gare">${displayGares(results)[0]}</span> vers <span class="lib-gare">${displayGares(results)[1]}</span></h4><ul class="departures-list">`;
	results.forEach((el) => {
		// Pour chaque ligne du tableau on crée une ligne <li> avec la date du jour
		li += `<li class="departs-du-jour ${lsDate.is_weekend(el[0].dateHeureDepart)}">
             <div class="date-departs">${lsDate.lsPrintDate(el[0].dateHeureDepart)}</div>
             <div class="programme">`;
		// On boucle dans chaque ligne du tableau principal
		el.forEach((el) => {
			//console.log("elt", el);

			let taux_occup = 1 - el.placeRestante / el.placeTotal;
			//console.log("taux_occup", taux_occup);
			let css_dispo = lsDom.classDispo(taux_occup);

			let book_horaire = '';
			if (lsDom.affiliation) {
				book_horaire = `${lsDom.BASE_URL_RESA}/ws?func=set_args&voyage=${tab_id_croisiere.join('.')}&date=${lsDate.date2set_args(el.dateHeureDepart).join('.')}&LS_PART=${lsDom.affiliation}`;
			} else {
				console.log("Date_heure", lsDate.date2set_args(el.dateHeureDepart));
				if (window.lsresa.cie === 'VOR') {
					// VOR a une particularité : il faut arriver en résa en étape2 donc pas de passage d'horaire classique
					// on passe l'horaire ≠ment avec un param GET LS_HORAIRE 
					// (Tous les paramètres GET qui commencent par "LS_" sont stockés dans le cookie LS_PARAM et sont disponibles dans session_resa.params)
					// Ne pas passet reset=1 car cela annule les autres params.
					book_horaire = `${lsDom.BASE_URL_RESA}/ws?func=set_args&voyage=${tab_id_croisiere.join('.')}&date=${lsDate.date2set_args(el.dateHeureDepart)[0]}&LS_HORAIRE=${lsDate.date2set_args(el.dateHeureDepart)}`;
				} else {
					book_horaire = `${lsDom.BASE_URL_RESA}/ws?func=set_args&voyage=${tab_id_croisiere.join('.')}&date=${lsDate.date2set_args(el.dateHeureDepart).join('.')}&reset=1`;
				}
			}

			let bateau = affiche_etapes ? el.etapes[0].nomBateau : el.nom;
			let display_dispo = affiche_dispo ? 'show' : 'dispo-hidden';
			let display_arrivee = affiche_etapes ? 'display-arrivee' : 'arrivee-hidden';
			let display_tps_traversee = affiche_tps_traversee ? 'display-duree' : 'duree-hidden';
			let port_arrivee = affiche_etapes ? el.etapes[el.etapes.length - 1].portArrive : ''; // On prend la dernière étape !
			//let heure_arrivee = affiche_etapes ? lsDate.lsPrintTime(el.etapes[el.etapes.length - 1].dateHeureArrive) : ''; // On prend la dernière étape !
			let date_heure_arrivee = affiche_etapes ? el.etapes[el.etapes.length - 1].dateHeureArrive : ''; // On prend la dernière étape !

			// On n'entoure l'horaire d'un lien que si l'horaire n'est pas complet.
			if (css_dispo !== 'complet') {
				// Dans le tooltip, on gère l'affichage ou non de la dispo avec des classes CSS
				// Idem pour le port et l'heure d'arrivée (en css)

				let heure_depart = `<a class="heure-depart ${css_dispo}" href="${book_horaire}" target="_blank" data-horaire="${lsDate
					.date2set_args(el.dateHeureDepart).join('.')}" data-time=${el.dateHeureDepart}>
							${lsDate.lsPrintTime(el.dateHeureDepart)}
				 </a>`

				li += `<div class="depart-wrapper C-${el.code}">
                ${heure_depart}
                <div class="tooltip">
                  <div class="boat">${bateau}</div>`;
				if (affiche_dispo) {
					li += `<div class="places-dispo ${display_dispo}">${el.placeRestante} pl. dispos</div>`;
				}
				if (affiche_etapes) {
					li += `<div class="${display_arrivee}">Arrivée à ${port_arrivee} vers ${lsDate.lsPrintTime(date_heure_arrivee)}</div>`;
				}
				if (affiche_tps_traversee && affiche_etapes) {
					// Il faut qu'on ait l'heure d'arrivée pour afficher le temps de traversée
					li += `<div class="${display_tps_traversee}">Traversée : ${lsDate.ms2time(
						lsDate.compare_date(el.dateHeureDepart, date_heure_arrivee)
					)}</div>`;
				}
				li += `</div></div>`;
			} else {
				// La croisière est complète
				li += `<div class="depart-wrapper">
                <span class="heure-depart ${css_dispo}">
                ${lsDate.lsPrintTime(el.dateHeureDepart)}
               </span>
               </div>`;
			}
		});
		li += `</div></li>`;
	});
	li += '</ul>';
	return li;
}

function btn_horaires_attach_event(bloc) {
	// bloc nous permet de savoir si on est dans le tableau des allers ou des retours
	let target = document.querySelectorAll('.' + bloc + ' .heure-depart'); // on cible tous les horraires du bloc, soit allers, soit retours.
	target.forEach((el) => {
		el.addEventListener('click', function (evt) {
			evt.preventDefault();
			evt.stopPropagation();
			const selected_btn_horaire = evt.currentTarget; // L'horaire cliqué

			// On crée une nouvelle div pour acceuillir le/les boutons de réservation à chaque click
			let bloc_reserver = lsDom.lsCreateElement('div', { class: 'bloc-reserver' });
			// A chaque click sur un btn horaire, on lui passe une classe "active"
			// Mais au préalable, il faut supprimer toute les classes "active" qui pourrait être présente sur un autre horaire
			target.forEach((el) => {
				if (el !== selected_btn_horaire) {
					el.classList.remove('active');
				}
				if (el.parentElement.querySelector('.bloc-reserver') !== null) {
					el.parentElement.querySelector('.bloc-reserver').remove(); // Suppr du bloc-reserver s'il existe. (permet d'en avoir qu'un seul à la fois)
				}
			});

			// FAIRE D'ABORD TOUT CE QUI EST COMMUN AU DEUX BLOCS
			if (selected_btn_horaire.classList.contains('active')) {
				// Si la classe active existe déjà sur btn sélectionné (on reclique sur le même) on désactive le btn.
				// Note : ne pas utiliser classList.toggle.
				selected_btn_horaire.classList.remove('active');
				//selected_btn_horaire.parentElement.querySelector('.bloc-reserver').remove();
			} else {
				selected_btn_horaire.classList.add('active');
			}

			// PUIS FAIRE LES SPÉCIFICITÉS DU BLOC.

			let inner_bloc_reserver;

			if (bloc === 'allers') {
				horaire_depart_choisi = selected_btn_horaire.getAttribute('data-horaire'); // On valorise l'horaire de l'aller
			} else if (bloc === 'retours') {
				horaire_retour_choisi = selected_btn_horaire.getAttribute('data-horaire'); // On valorise l'horaire du retour
				inner_bloc_reserver = `<a class="book-ar" target="_blank">Réserver<br>l'aller-retour</a>`;
				if (horaire_depart_choisi !== null) {
					selected_btn_horaire.parentElement.append(bloc_reserver);
					selected_btn_horaire.parentElement.querySelector('.bloc-reserver').innerHTML = inner_bloc_reserver;
				}
			}
			if (document.querySelector('.retours .book-ar') !== null) {
				document.querySelector('.retours .book-ar').addEventListener('click', function () {
					//- LS_reset : suppression du voyage 0 de la session_resa sinon l'internaute quand il change d'avis se retrouve systématiquement avec son choix précédent.
					let link_ar = '';
					if (lsDom.affiliation) {
						link_ar = `${lsDom.BASE_URL_RESA}/ws?func=set_args&voyage=${lsDom.id_voyage_ar}&date[0]=${horaire_depart_choisi}&date[1]=${horaire_retour_choisi}&LS_PART=${lsDom.affiliation}&LS_reset=1`;
					} else {
						link_ar = `${lsDom.BASE_URL_RESA}/ws?func=set_args&voyage=${lsDom.id_voyage_ar}&date[0]=${horaire_depart_choisi}&date[1]=${horaire_retour_choisi}&LS_reset=1`;
					}
					console.log('link_ar', link_ar);
					window.location.href = link_ar;
				});
			}
			console.log(horaire_depart_choisi, horaire_retour_choisi);
		});
	});
}